import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavModule } from '../nav-menu/nav.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { NoRolesComponent } from './no-roles/no-roles.component';




@NgModule({
  declarations: [
    NotFoundComponent,
    UnauthorizedComponent,
    NoRolesComponent
  ],
  imports: [
    NavModule,
    CommonModule,
    FormsModule,
    CoreModule
  ]
})
export class AuthModule { }
